export enum FootSideEnum {
  LEFT = 'left',
  RIGHT = 'right',
}
